import { toast } from "react-toastify";

import { useQueryClient } from "@tanstack/react-query";
import { cloudStorage } from "@tma.js/sdk-react";

import { Page } from "pages/ui/layout/page";
import { useHolderStore } from "shared/stores/holder-store";
import { getBiometry } from "shared/tg/utils/get-biometry";
import { Button } from "shared/ui/button";
import { catchError } from "shared/utils/catch-error";

export const Dev = () => {
  const queryClient = useQueryClient();
  const [_, setHolder] = useHolderStore();
  return (
    <Page>
      <Button
        onClick={async () => {
          try {
            if (!cloudStorage.clear.isAvailable()) return;
            await cloudStorage.clear();
            queryClient.invalidateQueries();
            toast.success("Storage cleared");
          } catch (error) {
            catchError(error);
          }
        }}
      >
        Clear storage
      </Button>

      <Button
        className="mt-6"
        onClick={async () => {
          try {
            const { biometry } = await getBiometry();
            await biometry.updateToken({ reason: "Want to delete" });
            setHolder(undefined);
            toast.success("Biometry Token has been deleted");
          } catch (error) {
            toast.error(
              error instanceof Error ? error.message : "something went wrong"
            );
          }
        }}
      >
        Delete Biometry Token
      </Button>

      <Button
        className="mt-6"
        onClick={async () => {
          try {
            const { biometry } = await getBiometry();
            biometry.openSettings();
          } catch (error) {
            toast.error(
              error instanceof Error ? error.message : "something went wrong"
            );
          }
        }}
      >
        Biometry Settings
      </Button>
    </Page>
  );
};
